import React from "react";
import { observer } from "mobx-react";
import { RegisteredUsersActivityTemplate } from "themes/administration/analytics/pages";
import { RegisteredUsersActivityViewStore } from "administration/analytics/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new RegisteredUsersActivityViewStore(rootStore, componentProps),
    "registeredUsersActivityViewStore"
)
@observer
class RegisteredUsersActivity extends React.Component {
    render() {
        return <RegisteredUsersActivityTemplate {...this.props} />;
    }
}

export default RegisteredUsersActivity;
